import React from "react";
import { Button, Upload } from "antd";
import { FormGroup, FormControl } from "react-bootstrap";

import "./styles.css";

const UploadFile = ({
    id,
    label = "",
    buttonText = "",
    width = "15%",
    handleImageChange,
    customRequest,
    fileList,
    errorText = "",
    isForm = false,
    helperText = "",
}) => {
    return (
        <div style={{ width: width }} className="ml-5">
            <FormGroup
                className={`${isForm ? "d-flex form-upload" : ""} flex-column`}
            >
                {/* <FormLabel htmlFor={`input-upload-${id}`}>{label}</FormLabel> */}
                <Upload
                    id={`input-upload-${id}`}
                    onChange={handleImageChange}
                    customRequest={customRequest}
                    fileList={fileList}
                >
                    <Button className={Boolean(errorText) && "input-upload-error"}>
                        {buttonText}
                    </Button>
                </Upload>
                {Boolean(errorText) && (
                    <FormControl.Feedback type="invalid" style={{ display: "block" }}>
                        {errorText}
                    </FormControl.Feedback>
                )}
                <div className="upload-helper-text">{helperText}</div>
            </FormGroup>
        </div>
    );
};
export default UploadFile;
